class NfeFilter {
  static get $inject() {
    return ['$filter', '$scope', 'gql']
  }

  constructor($filter, $scope, gql) {
    this.$filter = $filter
    this.gql = gql

    this.apply = (fun) => $scope.$applyAsync(fun)

    $scope.$watch(() => this.filter, () => {
      setTimeout(() => this.apply(() => this.submit()), 0)
    }, true)

    $scope.$watch(() => this.filter.busca, (newValue, oldValue) => {
      if (!oldValue && !!newValue) {
        this.filter.order = this.orderOptions[0].value
      }
    })

    $scope.$on('filterByEtiqueta', (_eventName, etiqueta) => {
      this.filter.etiquetas = [etiqueta]
    })

    this.hasManifesto = false

    this.tipoManifesto = [
      { value: 'CONFIRMACAO', tipo: 'Confirmação da operação' },
      { value: 'DESCONHECIMENTO', tipo: 'Desconhecimento da operação' },
      { value: 'NAO_REALIZADO', tipo: 'Operação não realizada' }
    ]

    this.tipoRealizado = [
      { value: '_EF', tipo: 'Eficiência fiscal' },
      { value: '_OUTROS', tipo: 'Outros meios' }
    ]

    this.eventoList = ['CONFIRMACAO', 'DESCONHECIMENTO', 'NAO_REALIZADO']
    this.realizadoPorList = ['_EF', '_OUTROS']
  }

  $onInit() {
    let inicial = new Date(new Date().setDate(new Date().getDate() - 30));
    let final = new Date();

    this.filter = {
      periodo: {
        inicial,
        final
      },
      etiquetas: []
    }

    this.buildOrderOptions()
  }

  submit() {
    if (this.form && this.form.$valid) {
      this.updateFilter()
    } else {
      this.onChange({ $newFilter: null })
    }
  }

  buildOrderOptions() {
    this.orderOptions = [
      { value: { sortField: 'RELEVANCIA', sortOrder: 'DESC' }, descricao: 'Relevância' },
      { value: { sortField: 'EMISSAO', sortOrder: 'DESC' }, descricao: 'Emissão mais recente' },
      { value: { sortField: 'EMISSAO', sortOrder: 'ASC' }, descricao: 'Emissão menos recente' },
      { value: { sortField: 'VALOR', sortOrder: 'DESC' }, descricao: 'Maior valor' },
      { value: { sortField: 'VALOR', sortOrder: 'ASC' }, descricao: 'Menor valor' }
    ]

    this.filter.order = this.orderOptions[1].value
  }

  updateFilter() {
    if (this.filter.chave)
      this.filter.chave = this.filter.chave.replace(/\D/g, '')

    if (!this.filter.busca && this.filter.order.sortField == 'RELEVANCIA')
      this.filter.order = this.orderOptions[1].value

    let filter = { ...this.filter, tipoEmissao: this.tipoEmissao, transferencia: false }

    for (let key in filter) if (filter.hasOwnProperty(key) && filter[key] === "") {
      delete filter[key]
    }

    if (filter.periodo) {
      if (filter.periodo.inicial)
        filter.emissaoInicial = filter.periodo.inicial.toISOString()

      if (filter.periodo.final)
        filter.emissaoFinal = filter.periodo.final.toISOString()
    }

    delete filter.periodo
    delete filter.order.$$hashKey

    if (filter.numero || filter.chave) {
      delete filter.transferencia
      delete filter.emissaoInicial
      delete filter.emissaoFinal
    }

    switch (filter.tipo) {
      case 'transferencia':
        filter.transferencia = true
        delete filter.tipo
        break
      case 'garantia':
        filter.retorno_garantia = true
        delete filter.tipo
        break
      case 'possui_xml':
        filter.possui_xml = true
        delete filter.tipo
        break
      case 'with_cte':
        filter.with_cte = true
        delete filter.tipo
        break
      case 'devolucao':
        filter.finalidade_emissao = '4'
        delete filter.tipo
        break
    }

    if (filter.busca) {
      let query = filter.busca
        .replace(/(\d{3})\.(\d{3})\.(\d{3})-(\d{2})/g, "$1$2$3$4")
        .replace(/(\d{2})\.(\d{3})\.(\d{3})\/(\d{4})-(\d{2})/g, "$1$2$3$4$5")

      query = query.replace(/ {1,}/ig, '+')

      if (this.tipoEmissao == 'TERCEIROS')
        filter.busca = { participante: 'emitente', query: query }
      else if (this.tipoEmissao == 'PROPRIA')
        filter.busca = { participante: 'destinatario', query: query }
    }

    filter.etiquetasIds = filter.etiquetas.length
      ? filter.etiquetas.map(e => e.id)
      : undefined

    delete filter.etiquetas

    this.onChange({ $newFilter: filter })
  }

  checkEvento(value, checked) {
    if (!checked) {
      this.eventoList = this.eventoList.filter(v => v != value)
    }

    if (checked && !this.eventoList.find(v => v == value)) {
      this.eventoList.push(value)
    }

    this.createManifestoFilter()
  }

  checkRealizadoPor(value, checked) {
    if (!checked) {
      this.realizadoPorList = this.realizadoPorList.filter(v => v != value)
    }

    if (checked && !this.realizadoPorList.find(v => v == value)) {
      this.realizadoPorList.push(value)
    }

    this.createManifestoFilter()
  }

  createManifestoFilter() {
    const eventoList = this.eventoList.length ? this.eventoList : ['CONFIRMACAO', 'DESCONHECIMENTO', 'NAO_REALIZADO']
    const realizadoPorList = this.realizadoPorList.length ? this.realizadoPorList : ['_EF', '_OUTROS']

    let options = []

    if (this.possuiManifesto)
      options = realizadoPorList.map((r) => eventoList.map((a) => a + r)).flatMap(x => x)
    else
      options = ['SEM_MANIFESTO']

    this.filter.possuiManifesto = options
  }
}

angular.module('eficienciaFiscalModule').component('nfeFilter', {
  controller: NfeFilter,
  bindings: {
    onChange: '&',
    tipoEmissao: '@',
    ferramenta: '@',
    empresaId: '<contratoId'
  },
  template: `
  <form class="fade-animation" name="$ctrl.form" ng-submit="$ctrl.submit()">
    <div class="row">
        <ef-filiais-selector class="form-group col-sm-12" name="filiaisIds" ng-model="$ctrl.filter.filiaisIds"
            contrato-id="$ctrl.empresaId" ferramenta="{{ $ctrl.ferramenta }}" cache-as="nfe-list" required>
        </ef-filiais-selector>
        <div class="form-group col-sm-6">
            <label>
                Data de emissão
                <i class="fa fa-trash-o text-danger cursor-pointer" ng-click="$ctrl.filter.periodo = undefined"
                    ng-if="$ctrl.filter.periodo && !$ctrl.required"></i>
            </label>
            <periodo-input name="emissao" ng-model="$ctrl.filter.periodo"></periodo-input>
        </div>
        <div class="form-group col-xs-4 col-sm-2">
            <label>
                Modelo
                <i class="fa fa-trash-o text-danger cursor-pointer" ng-click="$ctrl.filter.modeloIs = undefined"
                    ng-if="$ctrl.filter.modeloIs"></i>
            </label>
            <select class="form-control" ng-model="$ctrl.filter.modeloIs">
                <option value="nfe">NF-e</option>
                <option value="nfce">NFC-e</option>
            </select>
        </div>
        <div class="form-group col-xs-4 col-sm-2">
            <label>
                Série
                <i class="fa fa-trash-o text-danger cursor-pointer" ng-click="$ctrl.filter.serie = undefined"
                    ng-if="$ctrl.filter.serie"></i>
            </label>
            <input type="text" class="form-control" ng-model="$ctrl.filter.serie" ng-model-options="{ debounce: 500 }"
                maxlength="3">
        </div>
        <div class="form-group col-xs-4 col-sm-2">
            <label>
                Número
                <i class="fa fa-trash-o text-danger cursor-pointer" ng-click="$ctrl.filter.numero = undefined"
                    ng-if="$ctrl.filter.numero"></i>
            </label>
            <input type="text" class="form-control" ng-model="$ctrl.filter.numero" ng-model-options="{ debounce: 500 }">
        </div>
        <div class="form-group col-sm-3">
            <label>
                Tipo
                <i class="fa fa-trash-o text-danger cursor-pointer" ng-click="$ctrl.filter.tipo = undefined"
                    ng-if="$ctrl.filter.tipo != undefined"></i>
            </label>
            <select class="form-control" ng-model="$ctrl.filter.tipo">
                <option value="0">Entrada</option>
                <option value="1">Saída</option>
                <option value="transferencia">Transferência</option>
                <option value="devolucao">Devolução</option>
                <option ng-if="$ctrl.tipoEmissao == 'TERCEIROS'" value="garantia">Garantia</option>
                <option ng-if="$ctrl.tipoEmissao == 'TERCEIROS'" value="possui_xml">Possui XML</option>
                <option value="with_cte">Possui CT-e</option>
            </select>
        </div>
        <div class="form-group col-sm-3">
            <label>
                Status
                <i class="fa fa-trash-o text-danger cursor-pointer" ng-click="$ctrl.filter.status = undefined"
                    ng-if="$ctrl.filter.status != undefined"></i>
            </label>
            <select class="form-control" ng-model="$ctrl.filter.status">
                <option value="autorizada">Autorizado o uso da NF-e</option>
                <option value="cancelada">NF-e cancelada</option>
            </select>
        </div>
        <div class="form-group col-sm-6">
            <label>
                Chave
                <i class="fa fa-trash-o text-danger cursor-pointer" ng-click="$ctrl.filter.chave = undefined"
                    ng-if="$ctrl.filter.chave"></i>
            </label>
            <input type="text" class="form-control" ng-model="$ctrl.filter.chave" ng-model-options="{ debounce: 500 }">
        </div>
        <div class="form-group col-sm-6">
            <label>
                Busca
                <i class="fa fa-trash-o text-danger cursor-pointer" ng-click="$ctrl.filter.busca = undefined"
                    ng-if="$ctrl.filter.busca"></i>
            </label>
            <input type="text" class="form-control" placeholder="Razão Social, CNPJ, Descrição do item"
                ng-model="$ctrl.filter.busca" ng-model-options="{ debounce: 500 }">
        </div>
        <div class="form-group col-sm-6">
            <label>
                Etiquetas
                <i class="fa fa-trash-o text-danger cursor-pointer" ng-click="$ctrl.filter.etiquetas = []"
                    ng-if="$ctrl.filter.etiquetas.length">
                </i>
            </label>
            <ef-etiquetas-selector ng-model="$ctrl.filter.etiquetas" empresa-id="$ctrl.empresaId" position="end">
            </ef-etiquetas-selector>
        </div>

        <div class="form-group col-sm-6" ng-if="$ctrl.tipoEmissao == 'TERCEIROS'">
            <div class="form-group col-xs-12">
                <span>
                    Possui manifesto
                    <i class="fa fa-trash-o text-danger cursor-pointer"
                        ng-click="$ctrl.possuiManifesto = undefined; $ctrl.filter.possuiManifesto = undefined;"
                        ng-if="$ctrl.possuiManifesto != undefined"></i>
                </span>
                <div class="smart-form">
                    <div class="inline-group" style="margin: 0px">
                        <label class="radio no-break">
                            <input type="radio" ng-model="$ctrl.possuiManifesto" ng-value="true"
                                ng-click="$ctrl.createManifestoFilter()">
                            <i></i> Sim
                        </label>
                        <label class="radio no-break">
                            <input type="radio" ng-model="$ctrl.possuiManifesto" ng-value="false"
                                ng-click="$ctrl.createManifestoFilter()">
                            <i></i> Não
                        </label>
                    </div>
                </div>
            </div>

            <div ng-show="$ctrl.possuiManifesto" class="col-xs-12">
                <div class="form-group col-sm-6" style="padding: 0px;">
                    <label style="width: 100%">Evento</label>
                    <label ng-repeat="manifesto in $ctrl.tipoManifesto" style="width: 100%">
                        <input type="checkbox" class="checkbox" checklist-model="$ctrl.eventoList"
                            checklist-value="manifesto.value" ng-change="$ctrl.checkEvento(manifesto.value, checked)">
                        <span>{{manifesto.tipo}}</span>
                    </label>
                </div>
                <div class="form-group col-sm-6" style="padding: 0px;">
                    <label style="width: 100%">Realizado por</label>
                    <label ng-repeat="tipo in $ctrl.tipoRealizado" style="width: 100%">
                        <input type="checkbox" class="checkbox" name="tipo" checklist-model="$ctrl.realizadoPorList"
                            checklist-value="tipo.value" ng-change="$ctrl.checkRealizadoPor(tipo.value, checked)">
                        <span>{{tipo.tipo}}</span>
                    </label>
                </div>
            </div>
        </div>

        <div class="form-group col-sm-3">
            <label>Ordenar por</label>
            <select class="form-control" ng-model="$ctrl.filter.order"
                ng-options="option.value as (option.descricao) for option in $ctrl.orderOptions"></select>
        </div>

        <div class="form-group col-sm-3" ng-class="{'pull-right': $ctrl.tipoEmissao == 'PROPRIA'}">
            <label for="" class="hidden-xs">&nbsp;</label>
            <button type="submit" class="btn btn-primary btn-block"><i class="fa fa-refresh"></i> Atualizar</button>
        </div>
    </div>
  </form>
  `
})
